<app-toolbar (toggle)="toggle()"></app-toolbar>
<app-sidenav [opened]="leftOpened"></app-sidenav>
<app-footer></app-footer>